import BreadcrumbsLinks from './Breadcrumbs';

export default BreadcrumbsLinks;
